import Http from '../libs/http';

export default {
  // 获取评论列表
  getCommentList(params) {
    return Http.post('/sys/order_review_brief_query', params);
  },
};



// WEBPACK FOOTER //
// ./src/api/product-comment-api.js